import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Column 1 - Hazer Global */}
          <div>
            <h3 className="text-xl font-bold mb-4">Hazer Global</h3>
            <p className="mb-4 text-gray-600">Subscribe to our newsletter</p>
            <div className="flex mb-4">
              <input
                type="email"
                placeholder="Your email"
                className="bg-white border border-gray-200 rounded-l-md px-4 py-2 w-full focus:outline-none"
              />
              <button className="bg-[#ff9906] text-white px-4 py-2 rounded-r-md hover:bg-[#e68a00] transition-colors">
                Subscribe
              </button>
            </div>
          </div>

          {/* Column 2 - Support */}
          <div>
            <h3 className="text-xl font-bold mb-4">Support</h3>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start">
                <MapPin size={18} className="mr-2 mt-1 shrink-0 text-gray-500" />
                <span>111 Bijoy sarani, Dhaka, DH 1515, Bangladesh</span>
              </li>
              <li className="flex items-center">
                <Mail size={18} className="mr-2 shrink-0 text-gray-500" />
                <span>contact@hazerglobal.com</span>
              </li>
              <li className="flex items-center">
                <Phone size={18} className="mr-2 shrink-0 text-gray-500" />
                <span>+88015-88888-9999</span>
              </li>
            </ul>
          </div>

          {/* Column 3 - Account */}
          <div>
            <h3 className="text-xl font-bold mb-4">Account</h3>
            <ul className="space-y-2 text-gray-600">
              <li>
                <Link href="/account" className="hover:text-[#ff9906]">
                  My Account
                </Link>
              </li>
              <li>
                <Link href="/login" className="hover:text-[#ff9906]">
                  Login / Register
                </Link>
              </li>
              <li>
                <Link href="/cart" className="hover:text-[#ff9906]">
                  Cart
                </Link>
              </li>
              <li>
                <Link href="/wishlist" className="hover:text-[#ff9906]">
                  Wishlist
                </Link>
              </li>
              <li>
                <Link href="/shop" className="hover:text-[#ff9906]">
                  Shop
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-600">
              <li>
                <Link href="/privacy-policy" className="hover:text-[#ff9906]">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/terms" className="hover:text-[#ff9906]">
                  Terms Of Use
                </Link>
              </li>
              <li>
                <Link href="/faq" className="hover:text-[#ff9906]">
                  FAQ
                </Link>
              </li>
              <li>
                <Link href="/contact" className="hover:text-[#ff9906]">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 5 - Download App */}
          <div>
            <h3 className="text-xl font-bold mb-4">Download App</h3>
            <p className="text-sm text-gray-600 mb-2">Save $3 with App New User Only</p>
            <div className="flex space-x-2 mb-4">
              <div className="border border-gray-200 rounded-md p-2 bg-white">
                <img src="/placeholder.svg?height=80&width=80" alt="QR Code" width={80} height={80} />
              </div>
              <div className="flex flex-col space-y-2">
                <Link href="#" className="border border-gray-200 rounded-md p-1.5 bg-white">
                  <img src="/placeholder.svg?height=30&width=100" alt="App Store" width={100} height={30} />
                </Link>
                <Link href="#" className="border border-gray-200 rounded-md p-1.5 bg-white">
                  <img src="/placeholder.svg?height=30&width=100" alt="Google Play" width={100} height={30} />
                </Link>
              </div>
            </div>
            <div className="flex space-x-4 text-gray-500">
              <Link href="#" className="hover:text-[#ff9906]">
                <Facebook size={20} />
              </Link>
              <Link href="#" className="hover:text-[#ff9906]">
                <Twitter size={20} />
              </Link>
              <Link href="#" className="hover:text-[#ff9906]">
                <Instagram size={20} />
              </Link>
              <Link href="#" className="hover:text-[#ff9906]">
                <Youtube size={20} />
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-6 text-center text-sm text-gray-500">
          <p>© 2023 Hazer Global. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
